import React from 'react';
import Video from '~/Share/components/NextGen/Video';
import MessageTemplateEmbeds from '~/Share/containers/MessageTemplateEmbeds';
import type { MessageTemplateShare } from '~/types/models';
import { LandingPageType, RootState } from '~/types/redux/share';
import { LogoImage } from '../components/NextGen/LogoImage';
import { SentWithBonjoroBadgeStyle } from '@vimily/bonjoro-ui-components-v2';
import {
  addUtmToLink,
  UTM_CAMPAIGN_GREET_REFERRALS,
  UTM_MEDIUM_HEADER_BADGE,
  UTM_SOURCE_GREET_SHARE_PAGE,
} from '~/utils/add-utm-to-link';
import { BonjoroBadgeDesktop } from '~/App/Components/BonjoroBadgeDesktop';

export type ScrollableContentProps = {
  model: RootState['model'];
  messageTemplate: MessageTemplateShare;
  landingPageType: LandingPageType;
  slug?: string;
  useCustomLogo?: boolean;
  showSocialShareBar?: boolean;
  showSingleColumnLayout?: boolean;
  showBonjoroBadge?: boolean;
  anchorUrl?: string;
};

export default function ScrollableContent({
  messageTemplate,
  slug,
  useCustomLogo,
  model,
  landingPageType,
  showSocialShareBar,
  showSingleColumnLayout,
  anchorUrl,
  showBonjoroBadge,
}: ScrollableContentProps) {
  return (
    <div className='w-full h-auto flex flex-col justify-center relative'>
      <div className='scrollable'>
        <div className='content'>
          <LogoImage
            imageUrl={(useCustomLogo && messageTemplate.logo_url) || undefined}
            anchorUrl={anchorUrl}
          />
          <Video
            slug={slug}
            useDefaultPlayer={landingPageType !== LandingPageType.Greet}
            videoUrl={model.video_url}
            showSocialShareBar={showSocialShareBar}
            showSingleColumnLayout={showSingleColumnLayout}
          />
          <MessageTemplateEmbeds messageTemplate={messageTemplate} />
        </div>
      </div>
      {showBonjoroBadge && (
        <BonjoroBadgeDesktop
          className='absolute bottom-0 left-1/2 -translate-x-1/2 z-[105]'
          style={SentWithBonjoroBadgeStyle.Full}
          url={addUtmToLink('/', {
            utm_source: UTM_SOURCE_GREET_SHARE_PAGE,
            utm_medium: UTM_MEDIUM_HEADER_BADGE,
            utm_campaign: UTM_CAMPAIGN_GREET_REFERRALS,
          })}
        />
      )}
    </div>
  );
}
